module.exports = __webpack_public_path__ + "bgm-bedroom.7366d161.mp3";